export default {
    // Password Validetions with DOM manipulation
    passwordValidations: function (password, password_retry) {
        let letter, capital, number, length, special;
        let letterv, capitalv, numberv, lengthv, specialv = false;
        // if (!letter || !capital || !number || !length || !special) {
        letter = document.getElementById('letter');
        capital = document.getElementById('capital');
        number = document.getElementById('number');
        length = document.getElementById('length');
        special = document.getElementById('special');
        // }
        // Validate lowercase letters
        let lowerCaseLetters = /[a-z]/g;
        if (password.match(lowerCaseLetters)) {
            letter.classList.remove('invalid');
            letter.classList.add('valid');
            letterv = true;
        } else {
            letter.classList.remove('valid');
            letter.classList.add('invalid');
        }
        // Validate capital letters
        let upperCaseLetters = /[A-Z]/g;
        if (password.match(upperCaseLetters)) {
            capital.classList.remove('invalid');
            capital.classList.add('valid');
            capitalv = true;
        } else {
            capital.classList.remove('valid');
            capital.classList.add('invalid');
        }
        // Validate numbers
        let numbers = /[0-9]/g;
        if (password.match(numbers)) {
            number.classList.remove('invalid');
            number.classList.add('valid');
            numberv = true;
        } else {
            number.classList.remove('valid');
            number.classList.add('invalid');
        }
        // Validate length
        if (password.length >= 8) {
            length.classList.remove('invalid');
            length.classList.add('valid');
            lengthv = true;
        } else {
            length.classList.remove('valid');
            length.classList.add('invalid');
        }
        // Validate special letters
        let format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (format.test(password)) {
            special.classList.remove('invalid');
            special.classList.add('valid');
            specialv = true;
        }
        else {
            special.classList.remove('valid');
            special.classList.add('invalid');
        }
        return (letterv && capitalv && numberv && lengthv && specialv);
    },

    allTrue: function (obj) {
        for (let o in obj) {
            if (!obj[o]) { return false; }
        }
        return true;
    }
};
